import React, { useEffect } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { closeCustomModal, openCustomModal } from "views/lib/components/modals";
import { getSearch, getFilters, getStatuses } from "actions/promo-codes/actions";
import filterCaseInsensitive from "helpers/react-table-case-insensitive";
import ReactTable from "react-table";
import { Link } from "react-router-dom";
import moment from "moment";
import useSearchHook from "hooks/useSearch.hook";
import Filters from "./filters";
import CreateModal from "./create-modal";

const PromoCodes = ({
                      getSearch,
                      // deleteTemplate,
                      search,
                      loading,
                      closeCustomModal,
                      openCustomModal
                    }) => {
  const {
    page,
    size,
    filters,
    handleSearch,
    handleReset,
    handlePageChange,
    handleSortedChange,
    handlePageSizeChange
  } = useSearchHook(getSearch, {
    size: 20,
    sort: "usedAt,desc"
  });

  const handleCreate = (id = false) => {
    const modalObj = {
      modalSettings: {
        size: "lg",
        style: {
          width: 1200,
          maxWidth: "100%",
          padding: 20
        }
      },
      header: "Phone Codes",
      children: (
        <CreateModal
          onCancel={() => closeCustomModal(modalObj)}
          id={id}
        />
      ),
      handleClose: () => closeCustomModal(modalObj)
    };
    openCustomModal(modalObj);
  };

  const getColumns = () => [
    /* {
      Header: "#",
      accessor: "id",
    }, */
    {
      Header: "Code",
      accessor: "code",
    },
    {
      Header: "Amount",
      accessor: "amount",
    },
    {
      Header: "User",
      accessor: "owner",
      // eslint-disable-next-line react/display-name
      Cell: ({ original }) => (
        <Link to={`/users/${original.owner}`}>
          {original.owner}
        </Link>
      )
    },
    {
      Header: "Status",
      accessor: "status",
    },
    {
      Header: "Code",
      accessor: "code",
    },
    {
      id: "createdAt",
      Header: "Created Date",
      accessor: original => moment(original.createdAt)
        .format("HH:mm YYYY-MM-DD"),
      Cell: ({ original }) => moment(original.createdAt)
        .format("HH:mm YYYY-MM-DD"),
      width: 130
    },
    {
      id: "activatedAt",
      Header: "Activated Date",
      accessor: original => moment(original.activatedAt)
        .format("HH:mm YYYY-MM-DD"),
      Cell: ({ original }) => original.activatedAt ? moment(original.activatedAt)
        .format("HH:mm YYYY-MM-DD") : "N/A",
      width: 130
    },
    {
      id: "usedAt",
      Header: "Used Date",
      accessor: original => moment(original.usedAt)
        .format("HH:mm YYYY-MM-DD"),
      Cell: ({ original }) => original.usedAt ? moment(original.usedAt)
        .format("HH:mm YYYY-MM-DD") : "N/A",
      width: 130
    },
  ];

  useEffect(() => {
    getStatuses();
  }, []);

  return (
    <div className="w-100 p-2">
      <Filters
        handleCreate={() => handleCreate()}
        totalCount={search.total_count || 0}
        activeFilters={filters}
        handleReset={handleReset}
        handleSearch={handleSearch}
      />
      <ReactTable
        data={search.content || []}
        headerClassName="table-header"
        columns={getColumns()}
        pageSizeOptions={[10, 20, 50, 100]}
        resizable
        className="-striped -highlight"
        loading={loading}
        filterable={false}
        defaultFilterMethod={filterCaseInsensitive}
        getNoDataProps={() => ({
          style: {
            zIndex: 0
          }
        })}
        style={{
          height: "calc(100vh - 140px)"
        }}
        manual={true}
        pages={search.total_pages}
        page={page}
        pageSize={size}
        onSortedChange={handleSortedChange}
        onPageChange={handlePageChange}
        onPageSizeChange={handlePageSizeChange}
      />
    </div>
  );
};

const mapStateToProps = state => ({
  loading: state.promoCodes.loading,
  search: state.promoCodes.search,
});

const mapStateToDispatch = dispatch => ({
  openCustomModal: bindActionCreators(openCustomModal, dispatch),
  closeCustomModal: bindActionCreators(closeCustomModal, dispatch),
  getSearch: bindActionCreators(getSearch, dispatch),
  getFilters: bindActionCreators(getFilters, dispatch),
  getStatuses: bindActionCreators(getStatuses, dispatch)
});

export default connect(
  mapStateToProps,
  mapStateToDispatch
)(PromoCodes);



// WEBPACK FOOTER //
// ./src/views/pages/promo-codes/index.js